import {
  currencies,
  countries,
  activeCountries,
  jurisdictions
} from '@/modules/predefined/store/predefined.state';
import { Currency } from '@/modules/predefined/models/Currency';
import { Country } from '@/modules/predefined/models/Country';
import { Jurisdiction } from '@/modules/predefined/models/Jurisdiction';

export function setCurrencies(currencyList: Currency[]): void {
  currencies.value = currencyList;
}

export function setCountries(countryList: Country[]): void {
  countries.value = countryList;
}

export function setActiveCountries(countryList: Country[]): void {
  activeCountries.value = countryList;
}

export function setJurisdictions(jurisdictionList: Jurisdiction[]): void {
  jurisdictions.value = jurisdictionList;
}
